<!--
 * @Author: Lemon C
 * @Date: 2024-04-19 12:22:25
 * @LastEditTime: 2024-05-27 12:14:32
-->
<template>
    <div class="pdf-container">
        <div id="pdf-box" class="pdf-box"></div>
    </div>
</template>

<script setup>
import { onMounted, getCurrentInstance } from 'vue';
import PDFObject from 'pdfobject';

const { proxy } = getCurrentInstance();

onMounted(() => {
    let pdfurl = proxy.$route.query.pdfurl;
    let url = `${'https://developer.bjblackhole.com/#/pdfviewer?pdfurl='}${pdfurl}`;
    // PDFObject.embed(`${window.imageBaseUrl}/${pdfurl}`, "#pdf-box", {
    PDFObject.embed(url, '#pdf-box', {
        forcePDFJS: true,
        PDFJS_URL: 'pdfjs/web/viewer.html',
    });
});
</script>

<style lang="less" scoped>
.pdf-container {
    height: 100vh;

    .pdf-box {
        height: 100%;
    }
}
</style>
